@if (content) {
@if (basket.qty) {
<!-- mobile layout -->
<div class="p-b-12 bg-col-51"
     cy-basketView
     *ifSize="'SM'">
    <!-- title -->
    <div class="flex flex-middle p-a p-t-8 p-b-0">
        <h1 class="h3 col-1 flex-grow inline-block">{{'Basket' | translate}}</h1>
        <div class="p2 col-12 m-l inline-block">
            {{ (splitedBasketQty === 1 ? '% item' : '% items') | translate : splitedBasketQty }}
        </div>
    </div>
    <!-- free shippoing label -->
    <basket-free-shipping class="m-t-6 block"></basket-free-shipping>
    <!-- basket items -->
    @for (basketSplit of splitedBasket; track basketSplit; let isLast = $last) {
    @if (basketSplit?.qty) {
    <div class="bg-col-1 p-a p-t-2 p-b-2 flex flex-justify-between m-t"
         style="border-radius: 4px 4px 0px 0px;">
        <div class="flex flex-middle">
            <i class="col-w m-r-3 icon-medium"
               [ngClass]="basketSplit.isCollection ? 'icon-branch' : 'icon-delivery'"></i>
            <div>
                <p class="c1 col-w">{{basketSplit.name | translate}}</p>
                <span *ifSize="'XL'">&nbsp;</span>
                <p class="s1 col-w m-t-1-s m-t-1-m">
                    {{basketSplit.isCollection ? branchName : deliveryPostcodeService.postcode()}}</p>
            </div>
        </div>
        <div class="flex flex-middle">
            <button [iCmsModalOpen]="basketSplit.modalId"
                    class="link s2 m-r-2 col-w no-wrap">{{
                (basketSplit.isCollection ? 'Change Branch' : 'Change Postcode') | translate}}</button>
        </div>
    </div>
    <div class="p-l p-r bg-col-w m-b-8-m m-b-8-s">
        <ng-container *ngTemplateOutlet="deliveryDiscountBanner; context: {$implicit: basketSplit}"></ng-container>
        <!-- basket items -->
        @for (item of basketSplit.items; track item.id; let last = $last) {
        <basket-view-item class="block p-t p-b b-col-4"
                          [class.b-b]="!last"
                          [item]="item"
                          [context]="'basket'"
                          cy-basketproduct></basket-view-item>
        }
    </div>
    }
    }
    <div class="p-l p-r">
        <!-- voucher -->
        <basket-view-coupon-form class="block m-t bg-col-w-x bg-col-w-l"></basket-view-coupon-form>
        <!-- totals -->
        <basket-view-totals class="block m-t-5 m-t-8-s m-t-8-m"></basket-view-totals>

        <become-pro-banner [mode]="'offer'"
                           class="block m-t"></become-pro-banner>


        @if (!basket.isSalable) {
        <p class="p2 col-2 m-t center">
            {{basket.getBasketError() | translate}}
        </p>
        }
        <!-- submission -->
        <bottom-panel [bottomPanelRestricted]="['footer']">
            <basket-view-submit class="w-12" />
            <!-- paypal pay in three -->
            <ng-container *ngTemplateOutlet="paypalPayInThreeTmpl" />
            <div class="flex flex-justify-center m-t">
                <div class="b-a b-col-5 b-radius-4 p-a-2 flex flex-middle"
                     style="width: fit-content;">
                    <i class="icon-delivery col-11 m-r-1 icon-small"></i>
                    <p class="c1 col-11">{{'Order before 12:00pm for same day delivery' | translate}}</p>
                </div>
            </div>
        </bottom-panel>
    </div>
    <!-- bottom components -->
    <icms-outlet [components]="content.bottomComponents"></icms-outlet>
</div>
<!-- desktop layout -->
<div class="bg-col-51 p-t-9 p-b-20"
     cy-basketView
     *ifSize="'XL'">
    <div class="wrap">
        <div class="c-1"></div>
        <div class="c-6 p-b-9">
            <!-- title row -->
            <div class="flex flex-middle flex-justify-between">
                <h1 class="h3">{{'Basket' | translate}}</h1>
                <div class="p1">
                    {{ (splitedBasketQty === 1 ? '% item' : '% items') | translate : splitedBasketQty }}
                </div>
            </div>
            <!-- free shippoing label -->
            <basket-free-shipping class="m-t block"></basket-free-shipping>
            @for (basketSplit of splitedBasket; track basketSplit; let isLast = $last) {
            @if (basketSplit?.qty) {
            <div class="bg-col-1 p-a flex flex-justify-between m-t"
                 style="border-radius: 4px 4px 0px 0px;">
                <div class="flex">
                    <i class="col-w m-r-3"
                       [ngClass]="basketSplit.isCollection ? 'icon-branch' : 'icon-delivery'"
                       style="font-size: 18px;"></i>
                    <p class="p1 col-w">{{basketSplit.name | translate}}</p>
                    <span *ifSize="'XL'">&nbsp;</span>
                    <p class="s1 col-w m-t-1-s m-t-1-m">
                        {{basketSplit.isCollection ? branchName : deliveryPostcodeService.postcode()}}
                    </p>
                </div>
                <div>
                    <button class="link s2 m-r-2 col-w no-wrap"
                            [iCmsModalOpen]="basketSplit.modalId">
                        {{ (basketSplit.isCollection ? 'Change Branch' : 'Change Postcode') | translate}}</button>
                </div>
            </div>
            <div class="p-a bg-col-w">
                <ng-container
                              *ngTemplateOutlet="deliveryDiscountBanner; context: {$implicit: basketSplit}"></ng-container>
                <!-- basket items -->
                @for (item of basketSplit.items; track item.id; let last = $last) {
                <basket-view-item class="block p-t p-b b-col-4"
                                  [class.b-b]="!last"
                                  [item]="item"
                                  [context]="'basket'"
                                  cy-basketproduct></basket-view-item>
                }
            </div>
            }
            }
        </div>
        <div class="c-4">
            <div class=" p-t-9 p-b-9 p-l-6 p-r-6 bg-col-w b-radius-4">
                <h2 class="h3 center">{{'Order summary' | translate}}</h2>
                <!-- totals -->
                <basket-view-totals class="block m-t-6"></basket-view-totals>

                <become-pro-banner [mode]="'offer'"
                                   class="block m-t-8 m-t-2-s"></become-pro-banner>
                <!-- voucher -->
                <basket-view-coupon-form class="block m-t-3"></basket-view-coupon-form>
                <!-- submission -->
                <basket-view-submit class="block m-t-3" />
                <!-- paypal pay in three -->
                <ng-container *ngTemplateOutlet="paypalPayInThreeTmpl" />
                <div class="flex flex-justify-center m-t-8">
                    <div class="b-a b-col-5 b-radius-4 p-a-2 flex flex-middle"
                         style="width: fit-content;">
                        <i class="icon-delivery col-11 m-r-1 icon-small"></i>
                        <p class="c1 col-11">{{'Order before 12:00pm for same day delivery' | translate}}</p>
                    </div>
                </div>
                <!-- accepted payments -->
                <basket-view-paywith [payments]="content.payments || []"
                                     class="block m-t-8"></basket-view-paywith>
            </div>
            @if(content.reviewsImage) {
            <div class="center m-t-6">
                <href [link]="content.reviewsLink">
                    <img [width]="90"
                         [height]="45"
                         [dfImage]="content.reviewsImage"
                         [loaderParams]="{fitIn: true, fillColor: 'transparent'}" />
                </href>
            </div>
            }
        </div>
    </div>
    <!-- bottom components -->
    <icms-outlet [components]="content.bottomComponents"></icms-outlet>
</div>
}
@if (!basket.qty) {
<!-- empty back note -->
<div class="wrap p-b-12 p-t-20 center ">
    <p class="p1"
       *iCms="'emptyCopy' of content"></p>
    <button [routerLink]="'/' | lastCategoryPath"
            class="m-t block"
            [buttonStyle]><span *iCms="'emptyCtaCopy' of content"></span></button>
</div>
<!-- empty components -->
<icms-outlet [components]="content.emptyComponents"></icms-outlet>
}
}


<ng-template #deliveryDiscountBanner
             let-basketSplit>
    @if (!basketSplit.isCollection && basket.data.general_shipping_cost && basket.data.trade_shipping_cost &&
    !app.customer.model.isLoggedIn && basket.data.min_subtotal <= basket.totals.subtotal)
       {
       <div
       class="w-12 bg-col-1 p-l-3 p-r-3 p-t-2 p-b-2 m-t-4-m m-t-4-s col-w b-radius-4 p2">
        <span>{{ 'Delivery is available with a standard rate of' |
            translate}}&nbsp;<price [value]="basket.data.general_shipping_cost"></price></span>&nbsp;<span
              class="col-6">{{'or a
            discounted
            PROprice rate of' | translate}}&nbsp;<price [value]="basket.data.trade_shipping_cost"></price>.</span>
        </div>
        }
</ng-template>